// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchBuyNowsByIdsParams = {
    deployment: string,
    itemIds: number[],
};

type FetchItemsByIdsParams = {
    authToken: string,
    deployment: string,
    itemIds: number[],
};

type FetchItemShippingsByIdsParams = {
    authToken?: string,
    deployment: string,
    itemIds: number[],
};

type FetchListingAgentsByIdsParams = {
    agentIds: number[],
    authToken?: string,
    deployment: string,
};

export default {
    fetchBuyNowsByIds: ({ deployment, itemIds }: FetchBuyNowsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>buy-nows' });
            request.send({ itemIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchItemsByIds: ({ authToken, deployment, itemIds }: FetchItemsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>spa/small/items' });
            request.send({ ids: itemIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchItemShippingsByIds: ({ authToken, deployment, itemIds }: FetchItemShippingsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>item-shippings' });
            request.send({ itemIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchListingAgentsByIds: ({ agentIds, authToken, deployment }: FetchListingAgentsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ authToken, deployment, path: '<ITEM-API>listing-agents' });
            request.send({ agentIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
